import "./App.css";
import { connect, useDispatch, useSelector } from "react-redux";
import { Card, CardContent, FormControlLabel, Grid, Switch, Tab, Tabs} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useState } from "react";
import FormSettings from "./components/FormSettings";
import FormElements from "./components/FormElements";
import { DragDropContext } from "react-beautiful-dnd";
import FormContent from "./components/FormContent";
import {
  addNewGroupQuestion,
  addNewQuestion,
  addNewQuestionIntoGroup,
  addQuestionIntoParent,
  setPreview,
  sortQuestions,
  takeOutGroupQuestion,
  updateFormSettings,
  updateQuestionSetting,
} from "./actions";
import Footer from "./components/Footer";
import ExportExcelV2 from "./components/ExportExcelV2";
import QuestionConfig from "./components/QuestionConfig";
import { useEffect } from "react";
import Swal from "sweetalert2";

window.choiceslist = null;

const useStyles = makeStyles((theme) => ({
  first_nav: {
    padding: "15px",
  },
  second_nav: {
    top: 0,
    backgroundColor: "#ffffff",
    position: "fixed",
    // zIndex: 999,
    boxShadow:
      "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",
    },
  logo: {
    paddingLeft: "15px",
  },
  main: {
    marginTop: "50px",
  },
  form_page: {
    marginTop: "30px",
    marginBottom: "500px",
    width: "100%",
  },
  list: {
    width: 300,
  },
  fullList: {
    width: "auto",
  },
  cardContent: {
    padding: "25px !important",
  },
  questionConfig: {
    height: "calc(100vh - 60px)",
    overflowY: "auto",
    overflowX: "hidden",
    backgroundColor: "#ffffff",
    color: "#000",
    maxWidth: "400px",
    position:"fixed",
    right:"0"
  },
  formElements: {
    height: "calc(100vh - 60px)",
    overflowY: "auto",
    overflowX: "hidden",
    backgroundColor: "#ffffff",
    color: "#000",
    maxWidth: "400px",
    position:"fixed",
    left:"0"
  },
}));

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function App(props) {
  const { page_name } = useSelector((state) => ({ page_name: state.current_page}));
  const dispatch = useDispatch();
  const [tabIndex, setTabIndex] = useState(0);
  const newFormElements = [...window.FormEl]
  const [disableDropableGroup, setDisableDropableGroup] = useState(false);
  const [disableDropableGroupParent, setDisableDropableGroupParent] = useState(false);
  
  const handleChangeTab = (event, newValue) => { setTabIndex(newValue)};

  const handleListQuestionChild = (list) => {
    let newList = list.map((ques, index) => {
      const type = ques.XlsType;
      const appearanceGroup = ques.AppearanceGroup;
      const question_id = `${appearanceGroup.toLowerCase()}_${
        new Date().getTime() + index
      }`;
      const question_type = type.toLowerCase();
      if (ques?.allow_edit_name === "FALSE") {
        window.DisableQuestion["edit_name"] = [
          ...window.DisableQuestion?.edit_name,
          question_id,
        ];
      }
      let question_collector = newFormElements.filter(
        (element) => element.AppearanceGroup == appearanceGroup
      )[0];
      question_collector = {...question_collector, "Appearance" :'FALSE'}
      
      return {
        question_id: question_id,
        question_type: question_type,
        question_collector: question_collector,
        question: ques,
      };
    });
    return newList;
  };

  const handleOnDragStart = (result) => {
    if(
      (result.draggableId.indexOf("group_") > -1 || result.draggableId.indexOf("repeat_") > -1 ) &&
      result.source.droppableId.indexOf("form-content-droppable") > -1
    ){
      setDisableDropableGroup(true);
    }

    if (
      (result.draggableId.indexOf("group_") === -1 && result.source.droppableId.indexOf("group-droppable") > -1) ||
      (result.draggableId.indexOf("repeat_") === -1 && result.source.droppableId.indexOf("repeat-droppable") > -1)
    ){
      setDisableDropableGroupParent(true);
    }
  };

  const handleOnDragUpdate = (result) => {
    if (
      (result.draggableId.indexOf("group_") === -1 && result.source.droppableId.indexOf("group-droppable") > -1) ||
      (result.draggableId.indexOf("repeat_") === -1 && result.source.droppableId.indexOf("repeat-droppable") > -1 && result.destination === null)
    ){
      setDisableDropableGroupParent(false)
    }
  };

  const handleOnDragEnd = (result) => {
    setDisableDropableGroup(false)
    setDisableDropableGroupParent(false)
    const { source, destination } = result

    //add group template
    if(
      source.droppableId === "form-elements-droppable" &&
      destination?.droppableId === "form-content-droppable" &&
      result.draggableId.indexOf("GROUP_TEMPLATE") > -1
    ){
      const type = result.draggableId.split("##")
      const question_id = `group_template_${type[0].toLowerCase()}_${new Date().getTime()}`
      const question_type = type[1].toLowerCase()
      const question_collector = newFormElements.filter((element) => element.AppearanceGroup == type[0])[0]
      const destination_index = destination.index
      const list = window.GroupTemplateQuestions[type[0]]

      if (window?.GroupTemplateParent[type[0]]?.allow_edit_name === "FALSE") {
        if (!window.DisableQuestion["edit_name"]) {
          window.DisableQuestion["edit_name"] = [question_id]
        } else {
          window.DisableQuestion["edit_name"] = [ ...window.DisableQuestion?.edit_name, question_id]
        }
      }
      const list_child = handleListQuestionChild(list)
      dispatch(addNewGroupQuestion(page_name, question_id, question_type, question_collector, destination_index, list_child))
    }
    //add single template
    else if(
      source.droppableId === "form-elements-droppable" &&
      destination?.droppableId === "form-content-droppable" &&
      result.draggableId.indexOf("SINGLE_TEMPLATE") > -1
    ){
      const type = result.draggableId.split("##")
      const newQuestion = window.GroupTemplateQuestions[type[0]][0]
      const typeTemplate = type[0]
      newQuestion.AppearanceGroup = typeTemplate
      const question_id = `${typeTemplate.toLowerCase()}_${new Date().getTime()}`
      const question_type = newQuestion.type
      const question_collector = newFormElements.filter((element) => element.AppearanceGroup === newQuestion.AppearanceGroup)[0]
      newQuestion.collector = question_collector
      if (newQuestion?.allow_edit_name === "FALSE") {
        if (!window.DisableQuestion["edit_name"]) {
          window.DisableQuestion["edit_name"] = [question_id]
        } else {
          window.DisableQuestion["edit_name"] = [ ...window.DisableQuestion?.edit_name, question_id]
        }
      }
      if (!newQuestion.name) {
        newQuestion.name = question_id
      }
      const destination_index = destination.index
      dispatch(addNewQuestion(page_name, question_id, question_type, question_collector, destination_index,newQuestion))
    } 
    //add new question
    else if (
      source.droppableId === "form-elements-droppable" &&
      destination?.droppableId === "form-content-droppable"
    ){
      const type = result.draggableId.split("##")
      const question_id = `${type[0].toLowerCase()}_${new Date().getTime()}`
      const question_type = type[0] === "REPEAT" ? "repeat" : type[1].toLowerCase()
      const question_collector = newFormElements.filter((element) => element.AppearanceGroup === type[0])[0]
      const destination_index = destination.index
      dispatch(addNewQuestion(page_name, question_id, question_type, question_collector, destination_index))
    }

    //sort question
    if ( source.droppableId === "form-content-droppable" && destination?.droppableId === "form-content-droppable") {
      dispatch(sortQuestions(source.index, destination.index))
    }

    //add question to group parent
    if (
      source.droppableId === "form-content-droppable" &&
      (destination?.droppableId.indexOf("group") > -1 || destination?.droppableId.indexOf("repeat") > -1)
    ) {
      
      const container = destination.droppableId.split("##")[1]
      const question_id = result.draggableId
      const destination_index = destination.index

      dispatch(addQuestionIntoParent(container, question_id, destination_index))
    }

    //take question out of group

    if (
      (source.droppableId.indexOf("group") > -1 || source.droppableId.indexOf("repeat") > -1) &&
      destination?.droppableId === "form-content-droppable"
    ){
      const container = source.droppableId.split("##")[1]
      const question_id = result.draggableId
      const source_index = source.index
      const destination_index = destination.index
      dispatch(takeOutGroupQuestion(container, question_id, source_index,destination_index))
    }


    //add single temple or question into group

    if (
      source.droppableId === "form-elements-droppable" &&
      destination &&
      (destination.droppableId.indexOf("group") > -1 ||
        destination.droppableId.indexOf("repeat") > -1)
    ) {
      const destination_index = destination.index
      const container = destination.droppableId.split("##")[1]
      if (result.draggableId.indexOf("SINGLE_TEMPLATE") > -1) {
        const type = result.draggableId.split("##")
        const newQuestion = window.GroupTemplateQuestions[type[0]][0]
        const typeTemplate = type[0]
        const question_id = `${typeTemplate.toLowerCase()}_${new Date().getTime()}`
        const question_type = newQuestion.type
        const question_collector = newFormElements.filter(
          (element) => element.AppearanceGroup === type[0]
        )[0];
        newQuestion.collector = question_collector
        if (newQuestion?.allow_edit_name === "FALSE") {
          if (!window.DisableQuestion["edit_name"]) {
            window.DisableQuestion["edit_name"] = [question_id]
          } else {
            window.DisableQuestion["edit_name"] = [ ...window.DisableQuestion?.edit_name, question_id]
          }
        }
        if (!newQuestion.name) {
          newQuestion.name = question_id
        }
        dispatch(addNewQuestionIntoGroup( container, question_id, destination_index, page_name, question_type, question_collector, newQuestion))
      } else {
        const type = result.draggableId.split("##")
        const question_id = `${type[0].toLowerCase()}_${new Date().getTime()}`
        const question_type = type[1].toLowerCase()
        const question_collector = newFormElements.filter((element) => element.AppearanceGroup === type[0])[0]
        dispatch(addNewQuestionIntoGroup(container, question_id, destination_index, page_name, question_type, question_collector))
      }
    }

    return result
  }
  function slugify (str) {
    var map = {
      'a' : 'á|à|ả|ã|ạ|ă|ắ|ằ|ẳ|ẵ|ặ|â|ấ|ầ|ẩ|ẫ|ậ|À|Á|Ả|Ã|Ạ|Ă|Ắ|Ằ|Ẳ|Ẵ|Ặ|Â|Ấ|Ầ|Ẩ|Ẫ|Ậ',
      'e' : 'é|è|ẻ|ẽ|ẹ|ê|ế|ề|ể|ễ|ệ|É|È|Ẻ|Ẽ|Ẹ|Ê|Ế|Ề|Ể|Ễ|Ệ',
      'i' : 'í|ì|ỉ|ĩ|ị|î|Í|Ì|Ỉ|Ĩ|Ị',
      'o' : 'ó|ò|ỏ|õ|ọ|ơ|ớ|ờ|ở|ỡ|ợ|ô|ố|ồ|ổ|ỗ|ộ|Ó|Ò|Ỏ|Õ|Ọ|Ơ|Ớ|Ờ|Ở|Ỡ|Ợ|Ô|Ố|Ồ|Ổ|Ỗ|Ộ',
      'u' : 'ú|ù|ủ|ũ|ụ|ư|ừ|ứ|ử|ữ|ự|û|ü|Ú|Ù|Ủ|Ũ|Ụ|Ư|Ứ|Ừ|Ử|Ữ|Ự|Û|Ü',
      'c' : 'ç|Ç',
      'n' : 'ñ|Ñ',
      'd' : 'đ|Đ',
      'y' : 'ý|ỳ|ỷ|ỹ|ỵ|Ý|Ỳ|Ỷ|Ỹ|Ỵ'
    };
    for (var pattern in map) {
      str = str.replace(new RegExp(map[pattern], 'g'), pattern);
    };
    return str;
  };
  function convertToFamilyId(title) {
    let familyId = title.replace(/ /g, "_");
    familyId = slugify(familyId);
    
    return familyId.toUpperCase();
  }
  
  useEffect(()=>{
    Swal.fire({
      'title' : 'Enter form title',
      'input' : 'text', 
      'inputAttributes': {
        input: 'text',
        required: 'true',
        placeHolder: 'Do not enter special characters'
      },
      'customClass': {
        validationMessage: 'rta-validation-message'
      },
      'allowOutsideClick': false,
      inputValidator: (value) => {
        const regexInput = /^[a-zA-Z0-9_-\s]+$/
        if(value?.length === 0){
          return 'The form title cannot be blank'
        } else if (!value.match(regexInput)) {
          return 'The form title should not contain special characters'
        }
      },
      preConfirm: (value) => {
        dispatch(updateQuestionSetting( "displaytitle", 'label::en', value ));
        dispatch(updateFormSettings('form_title', value));
        dispatch(updateFormSettings('family', convertToFamilyId(value)));
        
      }
    })
  },[])

  return (
    <>
      <DragDropContext
        onDragStart={handleOnDragStart}
        onDragEnd={handleOnDragEnd}
        onDragUpdate={handleOnDragUpdate}
      >
        <HeaderLayout tabIndex={tabIndex} handleChangeTab={handleChangeTab}/>
        <WorkspaceLayout tabIndex={tabIndex} disableDropableGroup={disableDropableGroup} disableDropableGroupParent={disableDropableGroupParent}/>
      </DragDropContext>
    </>
  );
}

const mapStateToProps = (state, props) => {
  return {
    ...props,
  };
};

export default connect(mapStateToProps)(App);


const HeaderLayout = (props)=>{
  const { previewForm } = useSelector((state) => (
  {
    previewForm: state.previewForm,
  }
  ));
  const classes = useStyles();
  const dispatch = useDispatch()
  return(
    <Grid container justifyContent="space-between" alignItems="center" className={classes.second_nav} >
      <Grid item className={classes.logo}>
        <img
          src="./rta_logo.png"
          style={{ height: "35px" }}
          alt="logo"
        />
      </Grid>
      {
        !previewForm &&
        <Grid item>
          <Tabs
            value={props.tabIndex}
            onChange={props.handleChangeTab}
            indicatorColor="primary"
            textColor="inherit"
          >
            <Tab label="Survey" {...a11yProps(0)} />
            <Tab label="Settings" {...a11yProps(1)} />
          </Tabs>
        </Grid>
      }
      
      <Grid item>
        { !previewForm && <ExportExcelV2 /> }
        <FormControlLabel
          control={
            <Switch
              onChange={(e) => {
                dispatch(setPreview(!previewForm));
              }}
              name="preview_form"
            />
          }
          label="Preview Form"
        />
      </Grid>
    </Grid>
  )
}

const WorkspaceLayout = (props)=>{
  const { previewForm } = useSelector((state) => ({previewForm: state.previewForm}));
  const classes = useStyles();

  return(
    <Grid container className={classes.main} spacing={1} justifyContent="center" >
      <Grid item lg={3} md={3} xs classes={{ root: classes.formElements }} >
        { !previewForm && props.tabIndex === 0 && <FormElements/> }
      </Grid>
      <Grid item lg={6} md={6} xs>
        <Card className={classes.form_page}>
          <CardContent className={classes.cardContent}>
            {/* Form content tab */}
            <div hidden={props.tabIndex !== 0}>
              <FormContent
                disableDropableGroup={props.disableDropableGroup}
                disableDropableGroupParent={props.disableDropableGroupParent}
              />
            </div>
            {/* Form Setting tab */}
            <div hidden={props.tabIndex !== 1}>
              <FormSettings />
            </div>
          </CardContent>
        </Card>
        <Footer/>
      </Grid>
      <Grid item lg={3} md={3} xs classes={{ root: classes.questionConfig }} >
        {
          !previewForm &&  props.tabIndex === 0 &&
          <QuestionConfig />
        }
      </Grid>
    </Grid>
  )
}
